import api from './api';

export type DetectionLabelType = 'false_positive' | 'missed_detection';

export interface DetectionLabelPayload {
  pool_id: number;
  cctv_id: number;
  label_type: DetectionLabelType;
  /** 미검출은 bbox 권장, 오검출은 프레임만으로도 가능(하드 네거티브) */
  bbox?: [number, number, number, number];
  track_id?: number;
  class_name?: string;
  note?: string;
  frame_width?: number;
  frame_height?: number;
  frame_image_base64?: string;
}

export async function submitDetectionLabel(payload: DetectionLabelPayload) {
  return api.post('/api/detection-labels/', payload);
}
